import UserLogClient from '../../../../api/clients/identity/UserLogClient'
import { LogTableFilters } from '../../../../components/tables/DTO'
import { LogTable } from '../../../../controls/specifics/logs/LogTable'

type UserLogSectionProps = {
	userId?: number
}

export const UserLogSection = (props: UserLogSectionProps) => {
	const logClient = new UserLogClient()

	const getEntries = (filters: LogTableFilters) =>
		logClient.getUserLog({
			...filters,
			userId: props.userId,
		}).then((response) => response.data)

	const getEntriesCount = (filters: LogTableFilters) =>
		logClient.getUserLogCount({
			...filters,
			userId: props.userId,
		}).then((response) => response.data)

	return (
		<LogTable
			getEntries={getEntries}
			getEntriesCount={getEntriesCount}
		/>
	)
}